<label class="label-field label-font">
  {{ config.labelField }}
</label>
<div class="calender-container">
  <p-datepicker
    #fromCalendar
    (onFocus)="updateCalendarUI(fromCalendar)"
    [(ngModel)]="config.value"
    [showIcon]="true"
    [readonlyInput]="true"
    [minDate]="config.config.minDateValue"
    [maxDate]="config.config.maxDateValue"
    [disabledDates]="config.config.disableDates"
    [disabledDays]="[0, 6]"
    (onSelect)="onSelect($event)"
    (click)="onClick($event)"
    placeholder="mm/dd/yyyy"
  >
  </p-datepicker>

  <div class="calender-busy-indicator" *ngIf="config.config.busyIndicator">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw" aria-hidden="true"></i>
    <span class="loading-calender-text"> loading calendar... </span>
  </div>
</div>
